import {
  OTHER_EXCLUSION_AREA_TYPE_ID,
  toTypeId,
  type ExclusionAreaFeature,
  type ExclusionAreaTypeId,
} from './exclusionAreaTypeResolution'
import { getFeatureDisplayName } from './getFeatureDisplayName'

export const withExclusionAreaType = (
  exclusionAreas: ExclusionAreaFeature[] | null | undefined,
  featureId: string,
  newType: ExclusionAreaTypeId,
): ExclusionAreaFeature[] =>
  (exclusionAreas || []).map(exclusionArea => {
    if (exclusionArea.properties.id !== featureId) {
      return exclusionArea
    }

    // "Otro" parks the type label in `name` and the user's name in `otherName`. A catalog type has
    // no label to park, so the surviving name has to land in both or the save would post "Otro".
    const leavesOtherType =
      toTypeId(exclusionArea.properties.exclusionAreaTypeId) === OTHER_EXCLUSION_AREA_TYPE_ID &&
      toTypeId(newType) !== OTHER_EXCLUSION_AREA_TYPE_ID
    const displayName = getFeatureDisplayName(exclusionArea.properties)

    return {
      ...exclusionArea,
      properties: {
        ...exclusionArea.properties,
        featureGroup: 'exclusion',
        exclusionAreaTypeId: newType,
        name: leavesOtherType ? displayName : exclusionArea.properties.name,
        otherName: displayName,
        hasGrazingManagement: exclusionArea.properties.hasGrazingManagement === true,
      },
    }
  })
